module.exports = __webpack_public_path__ + "img/illu.716ca147.svg";